export const arrayToObject = (arr: string[]): { [key: string]: boolean } => {
    return arr.reduce((acc, value) => {
        acc[value] = false;
        return acc;
    }, {} as { [key: string]: boolean });
};